
import { Action, State } from './types';

export function detailsReducer(state: State, action: Action) {
  switch (action.type) {
    case "setActiveTab": {
      return {
        ...state,
        activeTab: action.data
      }
    }
    case "setParticipationsDetailsUrl": {
      return {
        ...state,
        participationsDetails: action.data
      }
    }
    default: {
      throw Error ("Error - unknown action type");
    }
  }
}
